import {
  Collapse,
  Divider,
  Empty,
  Form,
  InputNumber,
  Popover,
  Space,
  Spin,
} from 'antd'
import { SSegmentedTabs } from 'shj-components'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { isArray } from 'lodash-es'
import {
  getCalcQuoteBudgetPrice,
  getConfigurations,
  quoteBudgetPriceQueryTree,
  selectMainSpaceSpec,
} from '@/services/order'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import ConfigPriceList from '@/pages/orderService/components/ConfigPriceList'
import styles from './index.module.less'

const { Panel } = Collapse
const classNameObj = {
  工程总造价: 'total-project-cost',
  优惠汇总: 'offer-summary',
  合同金额: 'contract-amount',
  其他收款项目: 'other-income-items',
}

export default forwardRef(function BudgetPrice(props: any, ref) {
  const { couldEdit, quoteBudgetInfo, priceTabList, budgetId, quotationFlowId } = props
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [treeData, setTreeData] = useState<any>([])
  const [couldOperate, setCouldOperate] = useState(true)
  const [editFlag, setEditFlag] = useState(false)
  const timeout = useRef<any>(null)
  const [skuArgList, setSkuArgList] = useState<any>([])
  const [btnLoding, setBtnLoding] = useState(false)
  const [spaceArgList, setSpaceArgList] = useState<any>([])
  const [form] = Form.useForm()
  // 资金池
  const [priceTabvalue, setPriceTabvalue] = useState('1')
  const [priceListData, setPriceListData] = useState<any>([])
  const handlebaseInfo = async () => {
    if (quoteBudgetInfo?.skuArgJson) {
      let skuArgList = JSON.parse(quoteBudgetInfo?.skuArgJson || '[]')
      // skuArgList = skuArgList?.filter(item => !item.addFlag)
      console.log(skuArgList, 'skuArgList')

      setSkuArgList(skuArgList)
      let roomNum = 0
      let toiletNum = 0
      skuArgList.forEach((arg: any) => {
        if (arg.argCode === 'BED_ROOM' && Number(arg.argVal) !== NaN) {
          roomNum = Number(arg.argVal)
        }
        if (arg.argCode === 'toilet_num' && Number(arg.argVal) !== NaN) {
          toiletNum = Number(arg.argVal)
        }
      })
      const res = await selectMainSpaceSpec({
        quoteBudgetId: budgetId,
        roomNum,
        toiletNum,
      })
      if (Array.isArray(res)) {
        setSpaceArgList(res)
        form.setFieldValue('spaceQuoteBudgetItemList', res)
      }
    }
  }
  useEffect(() => {
    handlebaseInfo()
  }, [quoteBudgetInfo])

  useEffect(() => {
    if (open && skuArgList?.length) {
      handlebaseInfo()
    }
    if (!open) {
      form.resetFields()
    }
  }, [open])

  // 1. 初始化
  useEffect(() => {
    init()
  }, [quoteBudgetInfo])

  useEffect(() => {
    setCouldOperate(couldEdit)
  }, [couldEdit])

  useImperativeHandle(
    ref,
    () => ({
      init: () => init(),
    }),
    []
  )

  const init = (id?: string) => {
    setLoading(true)
    quoteBudgetPriceQueryTree({
      params: {
        quoteBudgetId: id || budgetId,
        quotationFlowId,
      },
    })
      .then((res: any) => {
        if (isArray(res)) {
          setTreeData([...res])
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // 根据id,更新价格
  const updateTreeById = (tree, id, newData) => {
    return tree.map(node => {
      if (node.id === id) {
        return { ...node, object: { ...node.object, ...newData } }
      }
      if (node.children) {
        const updatedChildren = updateTreeById(node.children, id, newData)
        return { ...node, children: updatedChildren }
      }
      return node
    })
  }

  const limitDecimals = value => {
    const reg = /^(\-)*(\d+)\.(\d\d).*$/
    return String(value).replace(reg, '$1$2.$3')
  }

  // 查询价格
  const debouncedSetValue = (treeEntityQuoteBudgetPriceTreeLongs, item) => {
    setLoading(true)
    getCalcQuoteBudgetPrice({
      params: {
        quoteBudgetId: budgetId,
      },
      data: treeEntityQuoteBudgetPriceTreeLongs,
    })
      .then(res => {
        setTreeData(res || [])
      })
      .finally(() => {
        setLoading(false)
      })
  }
  // 改变价格
  const changePrice = (newValue, item) => {
    const valueInput = limitDecimals(newValue)
    const treeEntityQuoteBudgetPriceTreeLongs = updateTreeById(treeData, item.id, {
      price: valueInput || '',
      editedFlag: true,
    })
    setTreeData(treeEntityQuoteBudgetPriceTreeLongs || [])
    if (timeout?.current) {
      clearTimeout(timeout?.current)
    }
    timeout.current = setTimeout(() => {
      debouncedSetValue(treeEntityQuoteBudgetPriceTreeLongs, item)
    }, 1500)
  }
  // 编辑框
  const renderEditInput = it => {
    // editFlag 是否处于编辑状态
    if (validateShowBtnFn(it) && editFlag) {
      return (
        <InputNumber
          step="0.01"
          type="number"
          formatter={limitDecimals}
          parser={limitDecimals}
          onInput={e => {
            changePrice(e, it)
          }}
          size="small"
          value={it?.object?.price}
          prefix="￥"
          style={{ width: 120 }}
          onClick={e => {
            e.stopPropagation()
          }}
        />
      )
    }
    return (
      <div
        className={`${styles.price} ${
          [
            'TOTAL_PROJECT_COST',
            'CONTRACT_AMOUNT',
            'DISCOUNT_SUMMARY',
            'OTHER_PAYMENT_ITEMS',
          ].includes(it?.object?.type)
            ? styles.redPrice
            : ''
        }`}
      >
        ￥{it?.object?.price ? `${numFormat({ value: it?.object?.price })}` : '0.00'}
      </div>
    )
  }
  // 渲染列表
  const renderItem = (item, index) => {
    return (
      <div className={styles.header}>
        <Popover content={item?.object?.name} placement="topLeft">
          <div className={styles.label}>
            {item.parentId !== '0' && <span className={styles.numberIndex}>{index + 1}</span>}
            {item?.object?.name}
          </div>
        </Popover>
        {renderEditInput(item)}
      </div>
    )
  }
  // 验证是否可编辑
  const validateShowBtnFn = node =>
    (node?.object?.mathType === 'CREATOR_ENTRY' || node?.object?.editFlag) && couldOperate

  const renderTreeComponent = (treeData, level) => {
    return (
      <div>
        {(treeData || []).map((item, index) => {
          if ((item?.children || []).length === 0) {
            return (
              <>
                <div
                  className={`${styles.noSubHeader} ${level === 0 ? styles.levelFirst : ''}  ${
                    level === 0 && classNameObj[item.label] ? classNameObj[item.label] : ''
                  }${!item.object.type && level === 0 ? styles.normalFee : ''} `}
                  key={item?.id}
                >
                  {renderItem(item, index)}
                </div>
              </>
            )
          }
          return (
            <Collapse
              ghost
              defaultActiveKey={['1']}
              className={`${classNameObj[item.label] ? classNameObj[item.label] : ''}  ${
                !item.object.type && level === 0 ? styles.normalFee : ''
              } `}
            >
              <Panel
                header={
                  <div className={`${level === 0 ? styles.levelFirst : ''}  `}>
                    {renderItem(item, index)}
                  </div>
                }
                key={'1'}
              >
                {renderTreeComponent(item?.children, level + 1)}
              </Panel>
            </Collapse>
          )
        })}
      </div>
    )
  }

  const priceTabListChange = value => {
    setPriceTabvalue(value)
    if (value === '2') {
      // 获取清单数据
      getConfigurations(budgetId).then(res => {
        console.log(res, '清单数据')
        if (res && Array.isArray(res)) {
          setPriceListData(res)
        }
      })
    }
  }
  const handleShow = () => {
    const flag = skuArgList.some((item: any) => item.argType === 'INPUT')
    return flag
  }
  return (
    <div className={styles.budgetPriceBox}>
      <div className={styles.baseTopBox}>
        <div
          style={{
            display: 'flex',
            alignItems: 'left',
            flexDirection: 'column',
            justifyContent: 'left',
          }}
        >
          {handleShow() ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
              <span className={styles.titleName}>基本信息</span>
              <Space split={<Divider type="vertical" />} style={{ marginRight: 30 }}>
                {skuArgList.map((item: any) => {
                  if (item?.argType === 'INPUT'&&!item?.addFlag) {
                    return (
                      <span>
                        {item?.argName}：{item?.argVal}
                      </span>
                    )
                  }
                })}
              </Space>
            </div>
          ) : null}
          {quoteBudgetInfo?.spaceQuoteBudgetItemList?.filter(item => item.spaceSpecParamValueId)
            ?.length ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'left',
                marginTop: '20px',
              }}
            >
              <span className={styles.titleName}>空间规格</span>
              <Space wrap split={<Divider type="vertical" />}>
                {quoteBudgetInfo?.spaceQuoteBudgetItemList
                  ?.filter(item => item.spaceSpecParamValueId)
                  ?.map(item => (
                    <span>
                      {item?.showName}：{item?.spaceSpecParamValueName}
                    </span>
                  ))}
              </Space>
            </div>
          ) : null}
        </div>
      </div>
      <div className={styles.priceBox}>
        {/* 预算信息 */}
        <Spin spinning={loading}>
          {(treeData || []).length > 0 ? (
            <div className={styles.priceDetailBox}>
              {priceTabvalue === '1' ? (
                <div className={styles.priceList}>{renderTreeComponent(treeData, 0)}</div>
              ) : (
                <ConfigPriceList data={priceListData}></ConfigPriceList>
              )}
            </div>
          ) : (
            <div className={styles.priceDetailPopover}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          )}
        </Spin>
      </div>
    </div>
  )
})
